import { render, staticRenderFns } from "./SportOrganizationSidebar.vue?vue&type=template&id=feccb7b8&scoped=true"
import script from "./SportOrganizationSidebar.vue?vue&type=script&lang=js"
export * from "./SportOrganizationSidebar.vue?vue&type=script&lang=js"
import style0 from "./SportOrganizationSidebar.vue?vue&type=style&index=0&id=feccb7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feccb7b8",
  null
  
)

export default component.exports